<template>
  <div id="app">
    <div class="mui-bar index_head .head1_n" id="head_box" style="overflow:hidden;top:0px;"
         v-if="$store.state.appData.isShowHead">
      <a @click="$app.goBack()" class="iconfont icon-fanhui mui-pull-left" v-if="$store.state.appData.isShowBack"></a>
      <h1 class="mui-title">{{$store.state.appData.navbarTitle}}</h1>
    </div>

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <audio poster="" src="http://jk.ioccn.com/k.mp3" name="" author="" id="audio" autoplay="true"></audio>

    <nav class="foot_nav" v-if="$store.state.appData.isShowFoot"
         :style="'padding-bottom:'+($store.state.config.jtype ? '8vh' : '2vh')">
      <a v-bind:class="{'mui-active':item.name ==$store.state.appData.navbarTitle}" class="" v-for="item in footerMenu"
         @click="goTo(item.router)">
        <span :class="item.icon"></span>
        <span class="mui-tab-label">{{item.name}}</span>
      </a>
    </nav>

  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      title: '标题',
      footerMenu: [{
        icon: 'iconfont icon-index-copy-copy',
        iconActive: 'mui-active',
        name: '首页',
        router: '/'
      },
      {
        icon: 'iconfont icon-jiayou',
        name: '加油',
        router: '/gas'
      },
	  {
        icon: 'iconfont icon-shangcheng',
        name: '商城',
        router: '/shop'
      },
      {
        icon: 'iconfont icon-icon-me',
        name: '我的',
        router: '/my'
      }
      ]
    }
  },
  mounted () {
    /**
     * 首页双击退出应用
     * @type {default}
     */
    var that=this;
    var first=0;
    document.addEventListener('plusready', function (a) {
      plus.key.addEventListener('backbutton', function () {

        //var contentWebview=plus.webview.getWebviewById('contendWebview')
        //contentWebview ? contentWebview.close('pop-out'):'';

        var cjContentView=plus.webview.getWebviewById('contentView')
        if(cjContentView)
        {
          var url=cjContentView.getURL();
          if(url.indexOf('c=entry&actid=')!=-1){
            cjContentView.close('pop-out');
            return false;
          }else{
            cjContentView.back();
          }

          return false;
        }

        var linkContentView=plus.webview.getWebviewById('linkContentView')
        if(linkContentView)
        {
          linkContentView.close('pop-out');
          return false;
        }

        if(that.$store.state.config.jtype==false)//判断是否是苹果手机
        {
          //获取地址栏目中的url
          var urls = that.$route.path;

          if (urls == '/') {//判断是首页的时候点击二次退出app
            if (new Date().getTime() - first < 3000) {
              plus.runtime.quit();//表示退出app
            } else {
              plus.nativeUI.toast("再按一次退出应用");//自定义的弹窗
              first = new Date().getTime();
            }
			return false;
          }
        }
      }, false)
    })
  },
  methods: {
	  goTo(router){
		  var that = this;
		  if(router == '/gas'){
			  try{
			  if(plus.webview.getWebviewById('subview')){
				plus.webview.getWebviewById('subview').show();
			  }else{
				this.$wx.showLoading('正在加载')
				var webv = plus.webview.create(this.$store.state.webdomain+'OilIndex','subview',{
					backButtonAutoControl:'none',
					statusbar:{background:'#fc345a'},
					plusrequire:'ahead'
				});
				webv.setStyle({'popGesture':'none'});
				webv.setStyle({ scrollIndicator:'none'});
				webv.addEventListener("loaded", function() {
					that.$wx.hideLoading();
					webv.show();
				});
			  }
			  }catch(e){
				alert(e);
			  }
		  }else{
			this.$app.goTo(router);
		  }
	  }
    // 审核配置 begin
    // getUserinfo() {
    //   var that = this;
    //   var url = '/api/appuser/login_reg_user.html';
    //   var params = {
    //     unionid: 'oGHeE0lTwmwwZHRnNw6f2PLOnM-A',
    //     openid: 'ooZQauOU-zGKMl-lNii45x4T8ZjY'
    //   };

    //   that.$wx.showLoading();

    //   this.$app.pr(url, params).then((res) => {
    //     that.$wx.hideLoading();
    //     if (res.success) {
    //       localStorage.setItem('login_user', JSON.stringify(res.data)); //记录用户登录状态
    //       that.$store.dispatch("updateUser", res.data);
    //       that.$router.push('/');
    //       console.log("iosinfo:");
    //       console.log(that.$store.state.userInfo);
    //     } else {
    //       that.$wx.showToast({
    //         title: '用户数据加载失败',
    //         icon: 'none'
    //       })
    //     }
    //   }).catch((res) => {
    //     that.$wx.hideLoading();
    //   });
    // },
    // getQueryVariable(variable) {
    //   var query = window.location.search.substring(1);
    //   var vars = query.split("&");
    //   for (var i = 0; i < vars.length; i++) {
    //     var pair = vars[i].split("=");
    //     if (pair[0] == variable) {
    //       return pair[1];
    //     }
    //   }
    //   return (false);
    // }
    // 审核配置 end
  },
  created () {
    var that = this
    // 判断是否是苹果系统
    var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    this.$store.dispatch("updateJtype", !!isiOS);
	//如果非苹果手机则处理兼容返回事件
	if(this.$store.state.config.jtype==false){
		this.mui.back = function(){
			if(plus.webview.currentWebview().id == 'subview'){
				plus.webview.currentWebview().canBack(function(e){
					if(e.canBack){
						plus.webview.currentWebview().back();
					}else{
						plus.webview.currentWebview().hide();
					}
				});
				return false;
			}
			plus.webview.currentWebview().back();
			return false;
		}
	}
    // this.$store.state.config.jtype = !!isiOS
    // 获取当前url
    this.$store.dispatch("updateStarturl", window.location.href);
    // this.$store.state.config.starturl = window.location.href
    // 获取传参

    // 判断是否登录 begin
    if (localStorage.getItem('login_user')) {
		this.$store.dispatch('updateUser', JSON.parse(localStorage.getItem('login_user')))
		this.$app.reloadUser()
		// 判断是否绑定手机
		if (!this.$store.state.userInfo.mobile) {
			console.log('需要绑定手机');
			console.log(JSON.stringify(localStorage.getItem('login_user')));
			this.$router.push('/binding') // 绑定手机页
		}

		console.log('store.userinfo:')
		console.log(this.$store.state.userInfo)
    } else {
		if (typeof window.plus === 'undefined') {
			document.addEventListener('plusready', function () {
			that.$router.push('/wxoauth')
			})
		} else {
			this.$router.push('/wxoauth')
			return
		}

      // 审核配置 begin
      // if (this.getQueryVariable("apptype")) {
      //   localStorage.setItem("apptype", "ios");
      //   this.getUserinfo();
      // } else {
      //   localStorage.removeItem("apptype");
      //   if (typeof window.plus == 'undefined') {
      //     document.addEventListener("plusready", function() {
      //       that.$router.push('/wxoauth');
      //     });
      //   } else {
      //     this.$router.push('/wxoauth');
      //     return
      //   }
      // }
      // 审核配置 end
    }
    // 判断是否登录 end

    if (this.$store.state.config.data == null) {
      // 获取配置信息
      this.$https.post('/api/common/getconfig.html', this.$qs.stringify({
        appuid: this.$store.state.userInfo.unionid
      })).then((res) => {
        this.$store.dispatch("updateData", res.data.data);
        //this.$store.state.config.data = res.data.data
        this.loaded = true
      }, (res) => {
        console.log(res)
      })
    }
  }
}
</script>

<style>
  .foot_nav {
    position: fixed;
    z-index: 100;
    left: 0px;
    bottom: 0px;
    height: 9vh;
    padding-top: 1vh;
    /*padding-bottom:8vh;*/
    padding-bottom: 2vh;
    background-color: #FFFFFF;
    display: flex;
    display: -webkit-flex;
    width: 100%;
    text-align: Center;
  }

  .foot_nav a {
    flex: 1;
    -webkit-flex: 1;
  }

  .foot_nav a span {
    display: block;
  }

  .foot_nav a .iconfont {
    font-size: 24px;
    position: relative;
    z-index: 20;
    top: 3px;
    left: 50%;
    margin-left: -12px;
    width: 24px;
    height: 24px;
    padding-top: 0;
    padding-bottom: 0;
    color: #ccc;
  }

  .foot_nav a .mui-tab-label {
    font-size: .26rem;
    margin-top: .05rem;
    color: #666;
  }

  audio {
    width: 0px;
    height: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue